
export const normalizeRecordList = (body) => {
  const raw = Array.isArray(body)
    ? body
    : Array.isArray(body?.data)
    ? body.data
    : Array.isArray(body?.results)
    ? body.results
    : body?.data?.id
    ? [body.data]
    : body?.id
    ? [body]
    : [];

  return [...raw]
    .filter((row) => row?.id)
    .sort((a, b) => new Date(a?.created_at) - new Date(b?.created_at));
};


export const isHtmlDocument = (value) =>
  typeof value === "string" && value.includes("<");

export const isWithinEditWindow = (createdAt) => {
  if (!createdAt) return true; 
  const created = new Date(createdAt).getTime();
  if (Number.isNaN(created)) return true;
  return Date.now() - created < 24 * 60 * 60 * 1000;
};
